/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import SubTitle from 'DesignSystem/SubTitle/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Content/Home/AppointmentBookings/Content/BookingDetails/DateTimeUnScheduled/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<SubTitle
  viewPath={`${viewPath}/SubTitle`}
 marginTop={dtSpaceXs}
 text="Not Scheduled"
 color="rgb(237,55,26)"
/>
{children}
</React.Fragment>)
}